import fp from 'lodash/fp';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import moment from 'moment-timezone';
import { pattern, size, media } from '@deerplusofficial/pos-helper';
import { withClientProvider } from '@deerplusofficial/pos-hoc';
import withTopbar from '../../assist/withTopbar';
import withChannelGuard from '../../assist/withChannelGuard';
import { withQueryOrders, withQueryChannel } from '../../model/Queries';
import { Container } from '../../components';
import Header from './Header';
import List from './List';
import DetailDrawer from './DetailDrawer';
import InnperWrapper from './InnerWrapper';

const Inner = styled(InnperWrapper)`
  flex-grow: 1;
  overflow: auto;
  padding-bottom: ${size.toolbarToggle};
  ${media(
    'tablet',
    css`
      padding-bottom: 0;
    `
  )};
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`;

class Orders extends Component {
  static propTypes = {
    ordersCount: PropTypes.number,
    orders: PropTypes.arrayOf(PropTypes.shape()),
    onQueryOrders: PropTypes.func,
  };

  static defaultProps = {
    onQueryOrders: fp.identity,
  };

  state = {
    page: 1,
    isShowTopbar: false,
    fetching: false,
    orderId: '',
    startDate: moment()
      .hour(0)
      .minute(0),
    endDate: moment()
      .hour(23)
      .minute(59),
    orderNumber: '',
  };

  componentDidMount() {
    this.onQueryOrders();
  }

  get activeOrder() {
    return fp.find({ id: this.state.orderId })(this.props.orders);
  }

  containerRef = node => (this.container = node);

  onTopbarToggleClick = () =>
    this.setState({ isShowTopbar: !this.state.isShowTopbar });

  onQueryOrders = async (page = 1) => {
    const { onQueryOrders } = this.props;
    const { startDate, endDate, orderNumber } = this.state;
    this.setState({ fetching: true });
    await onQueryOrders({ startDate, endDate, orderNumber, page });
    this.setState({ page, fetching: false });
  };

  onPageChange = async (page = 1) => {
    await this.onQueryOrders(page);
    this.container.scrollTop = 0;
    this.setState({ orderId: '' });
  };

  onRefetch = () => this.onQueryOrders(this.state.page);

  onStartDateChange = startDate => this.setState({ startDate });

  onEndDateChange = endDate => this.setState({ endDate });

  onOrderNumberChange = event => {
    const orderNumber = fp.get(['target', 'value'])(event);

    if (!pattern.order_number.test(orderNumber)) return;

    this.setState({ orderNumber });
  };

  onOrderDetailOpen = orderId => this.setState({ orderId });

  onOrderDetailClose = () => this.setState({ orderId: '' });

  render() {
    const { orders, ordersCount } = this.props;
    const {
      isShowTopbar,
      startDate,
      endDate,
      orderNumber,
      page,
      fetching,
      orderId,
    } = this.state;

    return (
      <React.Fragment>
        <Container>
          <Inner containerRef={this.containerRef}>
            <Card>
              <Header
                active={isShowTopbar}
                startDate={startDate}
                endDate={endDate}
                orderNumber={orderNumber}
                onToggleClick={this.onTopbarToggleClick}
                onQueryOrders={this.onQueryOrders}
                onStartDateChange={this.onStartDateChange}
                onEndDateChange={this.onEndDateChange}
                onOrderNumberChange={this.onOrderNumberChange}
              />
              <List
                page={page}
                loading={fetching}
                onPageChange={this.onPageChange}
                onRefetch={this.onRefetch}
                onOrderDetailOpen={this.onOrderDetailOpen}
                onOrderDetailClose={this.onOrderDetailClose}
                orders={orders}
                orderId={orderId}
                totalCounts={ordersCount}
              />
            </Card>
          </Inner>
        </Container>
        <DetailDrawer
          active={fp.size(orderId) > 0}
          order={this.activeOrder}
          onClose={this.onOrderDetailClose}
          onRefetch={this.onRefetch}
        />
      </React.Fragment>
    );
  }
}

export default fp.compose(
  withClientProvider(),
  withChannelGuard(),
  withQueryChannel(),
  withQueryOrders(),
  withTopbar({ search: false })
)(Orders);



// WEBPACK FOOTER //
// ./src/pages/Orders/Orders.js